"use client";

import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactDetails() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="contact-details" ref={containerRef} className="bg-background py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {}
          <div ref={textRef} className={`space-y-10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            {}
            <div className="space-y-3">
              
            </div>

            {}
            <div className="space-y-3">
              
            </div>

            {}
            <div className="space-y-3">
              <div className="flex items-start gap-4">
                <Mail className="size-6 text-accent mt-1 shrink-0" />
                <div>
                  <h3 className="font-display font-semibold text-2xl text-foreground mb-2">
                    Email
                  </h3>
                  <Link to="mailto:contact@westindiandigital.com" className="text-muted-foreground text-lg leading-relaxed hover:text-accent transition-colors duration-[var(--duration-fast)]">contact@wimcodigital.com</Link>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Mail className="size-6 text-accent mt-1 shrink-0" />
                <div>
                  <h3 className="font-display font-semibold text-2xl text-foreground mb-2">Career Enquiries</h3>
                  <Link to="mailto:hr@wimcodigital.com" className="text-muted-foreground text-lg leading-relaxed hover:text-accent transition-colors duration-[var(--duration-fast)]">hr@wimcodigital.com</Link>
                </div>
              </div>
            </div>

            {}
            <div className="pt-6 border-t border-border">
              <h3 className="font-display font-semibold text-xl text-foreground mb-4">
                Connect With Us
              </h3>
              <div className="flex items-center gap-4">
                <Link to="https://twitter.com/westindiandigital" newTab className="size-11 flex items-center justify-center rounded-md border border-border bg-background hover:bg-accent hover:border-accent hover:text-foreground-accent transition-all duration-[var(--duration-fast)] focus-ring" aria-label="Twitter">
                  <svg className="size-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </Link>
                <Link to="https://linkedin.com/company/westindiandigital" newTab className="size-11 flex items-center justify-center rounded-md border border-border bg-background hover:bg-accent hover:border-accent hover:text-foreground-accent transition-all duration-[var(--duration-fast)] focus-ring" aria-label="LinkedIn">
                  <svg className="size-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </Link>
                <Link to="https://github.com/westindiandigital" newTab className="size-11 flex items-center justify-center rounded-md border border-border bg-background hover:bg-accent hover:border-accent hover:text-foreground-accent transition-all duration-[var(--duration-fast)] focus-ring" aria-label="GitHub">
                  <svg className="size-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          {}
          <div ref={mapRef} className={`relative overflow-hidden rounded-lg shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${mapVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="aspect-[4/3] w-full overflow-hidden bg-muted">
              <img src="https://calm-primate.10web.cloud/wp-content/uploads/2026/02/Screenshot-2026-02-12-at-4.17.53-PM.png" alt="Caribbean location map" className="size-full object-cover transition-transform duration-500 ease-[var(--ease-smooth)] hover:scale-105" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}